export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center pt-32"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/69e4a7b673ce6b54197ec84ba1644bcf.jpeg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Where Style<br />Meets Precision
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-10 leading-relaxed max-w-2xl">
            Experience professional grooming services in a welcoming atmosphere. 
            I specialize in classic cuts, modern styles, and everything in between.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://book.squareup.com/appointments/87v5f18dxg1ebp/location/LBKWXNEF1FVM4/services"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-amber-500 text-black px-8 py-4 rounded-full text-lg font-semibold hover:bg-amber-400 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Book Appointment
            </a>
            <button 
              onClick={() => {
                const element = document.getElementById('services');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-black transition-all cursor-pointer whitespace-nowrap"
            >
              View Services
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
